
export function createLegalRepresentative(legalRepresentativeRepository, legalRepresentative) {
  return legalRepresentativeRepository.save(legalRepresentative);
}
